import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from "@tanstack/react-query";
import { App } from "antd";
import { handleError } from "api";
import { EventsApiService } from "features/events";

// import { Event } from "types/event";
import { eventsQueryKeys } from "./query-keys";

const { strategicpartnertitle } = EventsApiService();


type StrategicPartnerTitleResponse = {
  title: string;
  titleAr: string;
};

const getEventQuery = (
  id: string,
  options?: UseQueryOptions<StrategicPartnerTitleResponse>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<StrategicPartnerTitleResponse>;
  options?: UseQueryOptions<StrategicPartnerTitleResponse>;
} => ({
  queryKey: eventsQueryKeys.detail(id),

  queryFn: ({ signal }) =>
    strategicpartnertitle(id, { config: { signal } }),

  ...(options || {}),
});

export const useGetStrategictitle = (
  id: string,
  options?: UseQueryOptions<StrategicPartnerTitleResponse>
) => {
  const { message } = App.useApp();

  return useQuery<StrategicPartnerTitleResponse, Error>(
    getEventQuery(id, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);
        message.error(uiMessage);
      },
      ...(options || {}),
    })
  );
};

export { strategicpartnertitle };
